import React from "react";
import { Spinner, SpinnerProps } from "@fluentui/react-components";

interface NewformaSpinnerProps {
    size?: SpinnerProps["size"];
    label?: string;
    className?: string;
}

export const NewformaSpinner: React.FC<NewformaSpinnerProps> = ({ size, label, className }) => {
    return <Spinner size={size} label={label} className={className} />;
};
